// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__container___CglYR {
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    background-color: rgba(0, 0, 0, 0.3);
    justify-content: center;
    align-items: center;
    transition: opacity 0.3s ease;
}

.style__innerContainer___CV8jX {
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    border-radius: 12px;
        overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modals/style.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;QACf,gBAAgB;AACxB","sourcesContent":[".container {\n    position: fixed;\n    z-index: 100;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    flex-direction: column;\n    background-color: rgba(0, 0, 0, 0.3);\n    justify-content: center;\n    align-items: center;\n    transition: opacity 0.3s ease;\n}\n\n.innerContainer {\n    display: flex;\n    flex-direction: column;\n    background-color: #ffffff;\n    border-radius: 12px;\n        overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style__container___CglYR`,
	"innerContainer": `style__innerContainer___CV8jX`
};
export default ___CSS_LOADER_EXPORT___;
